const AggregateRoot = require('../ddd/AggregateRoot');
const _ = require('../../lodash');

class Channel extends AggregateRoot {
   constructor({ user, logger }) {
      super({ user, logger });
   }

   get agt() {
      return 'Channel';
   }

   async createNew({ idChannel, noChannel, title, noChannelType }) {
      const tid = this.domainUser.tid;

      let p = {
         aid: idChannel,
         noChannel,
         title,
         noChannelType,
         tid,
         frames: []
      };

      this.apply('CHANNEL_CREATED', p);

      var o = _.omit(p, ['aid', 'tid']);

      this.setData(
         {
            properties: _.merge(
               {
                  id: p.aid
               },
               o
            )
         },
         true
      );
   }

   deleteFrame({ idFrame, actionedOn }) {
      const normalizedIdFrame = idFrame?.toLowerCase();
      const { noChannel } = this._properties;

      const idx = this._properties.frames.findIndex((frame) => frame.id?.toLowerCase() === normalizedIdFrame);
      const frame = idx !== -1 ? this._properties.frames[idx] : null;

      if (frame == null || frame.deleted === true) {
         return { frame: frame ? { ...frame } : null, becameHidden: false };
      }

      const p = {
         noChannel,
         idChannel: this.id,
         noFrame: frame.no,
         idFrame: frame.id,
         actionedOn
      };

      this.apply('FRAME_DELETED_FROM_CHANNEL', p);

      frame.deleted = true;
      frame.upd = actionedOn;

      return { frame: { ...frame }, becameHidden: true };
   }

   addFrame({ idFrame, meta, content, actionedOn }) {
      const normalizedIdFrame = idFrame?.toLowerCase();
      const { noChannel } = this._properties;
      const existingFrame = this._properties.frames.find((frame) => frame.id?.toLowerCase() === normalizedIdFrame);

      if (existingFrame && existingFrame.deleted !== true) {
         return { frame: { ...existingFrame }, becameVisible: false };
      }

      const p = {
         noChannel,
         idChannel: this.id,
         noFrame: existingFrame ? existingFrame.no : null,
         idFrame: existingFrame ? existingFrame.id : idFrame,
         meta,
         content,
         actionedOn
      };

      this.apply('FRAME_ADDED_TO_CHANNEL', p);

      if (existingFrame) {
         existingFrame.upd = actionedOn;
         existingFrame.noUser = this.domainUser.noUser;
         existingFrame.deleted = false;
         existingFrame.content = content;
         existingFrame.meta = meta;

         return { frame: { ...existingFrame }, becameVisible: true };
      }

      const frame = {
         id: idFrame,
         upd: actionedOn,
         noUser: this.domainUser.noUser,
         deleted: false,
         content,
         meta
      };

      this._properties.frames.push(frame);

      return { frame: { ...frame }, becameVisible: true };
   }

   updateAssetUris({ idAsset, idFrame, localUri, remoteUri }) {
      idFrame = idFrame?.toLowerCase();

      const { noChannel } = this._properties;

      const idx = this._properties.frames.findIndex((frame) => frame.id === idFrame);
      const frame = idx !== -1 ? this._properties.frames[idx] : null;
      const noFrame = frame ? frame.no : null;

      if (!frame?.content?.media || frame.content.media.id != idAsset) {
         return;
      }

      const media = {
         ...frame.content.media,
         localUri
      };

      if (remoteUri) {
         media.remoteUri = remoteUri;
      }

      const content = {
         ...frame.content,
         media
      };
      const uri = media.localUri || media.remoteUri;
      const mimeType = media.mimeType;
      const mimeKind = mimeType?.startsWith('image/')
         ? 'image'
         : mimeType?.startsWith('audio/')
         ? 'audio'
         : mimeType?.startsWith('video/')
         ? 'video'
         : null;
      const populatedKinds = ['image', 'audio', 'video'].filter((kind) => Object.prototype.hasOwnProperty.call(content, kind));
      const kind = mimeKind || (populatedKinds.length === 1 ? populatedKinds[0] : null);

      if (kind) {
         content[kind] = uri;
      } else {
         for (const populatedKind of populatedKinds) {
            content[populatedKind] = uri;
         }
      }

      frame.content = content;

      this.apply('FRAME_ASSET_URIS_UPDATED', {
         content,
         idAsset,
         noChannel,
         idChannel: this.id,
         idFrame,
         noFrame
      });
   }

   // protected
}

module.exports = Channel;
